import {
  CREATE_USER,
  GET_USER,
  SET_ALL_USER,
  UPDATE_USER,
  SET_ALL_USER_SELECT,
  SET_ALL_CORPORATE_USER,
  SET_SPEAKER
} from "../../reducerTypes";

const initialState = {
  currentUser: {},
  userList: [],
  selectData: [],
  corporateUserList: [],
  speakerList: [],
};

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ALL_USER:
      return {
        ...state,
        userList: action.payload,
      };
    case CREATE_USER:
      return {
        ...state,
        currentUser: action.payload,
      };
    case GET_USER:
      return {
        ...state,
        currentUser: action.payload,
      };
    case UPDATE_USER:
      return {
        ...state,
        currentUser: action.payload,
      };
    case SET_ALL_USER_SELECT:
      const contentData = action.payload ? action.payload : [];
      const selectData = [];
      contentData.map((data) => {
        selectData.push({
          value: data.id,
          label: `${data.prefix ? data.prefix + " " : ""}${data.name} | ${
            data.code
          } | ${data.email ? data?.email : data?.phone}`,
        });
      });
      return {
        ...state,
        selectData: selectData,
      };
    case SET_ALL_CORPORATE_USER:
      return {
        ...state,
        corporateUserList: action.payload,
      };
    case SET_SPEAKER:
      return {
        ...state,
        userList: action.payload,
      };
    default:
      return state;
  }
};

export default userReducer;
